module.exports = {
	"header.logo.title": "GROHE - Pure Freude an Wasser",
	"footer.privacy.text": "Gizlilik",
	"footer.privacy.url": "https://www.grohe.com.tr/tr_tr/gizlilik.html",
	"footer.disclaimer.text": "Yasal Uyarı",
	"footer.disclaimer.url": "https://www.grohe.com.tr/tr_tr/bilgilendirme.html",
	"footer.copyright": "&copy; 2017 GROHE Limited",
	"homepage.headline": "GROHE Su Sistemleri Yapılandırıcısı",
	"homepage.introtext": "İhtiyaçlarınıza uygun GROHESu  Sistemini yapılandırmak için aşağıdaki soruları cevaplayın.",
	"homepage.buttonStart": "Başla",
	"homepage.buttonStartTracking": "showersystem-configurator/start",
	"404.title": "404 Sayfa Bulunamadı",
	"404.link.goBack": "Giriş sayfasına dön",
	"configurator.button.seeResults": "Sonuçları göster",
	"question1.question": "Nasıl bir su arıyorsunuz?",
	"question1.option1.text": "Yiyecek ve içecekleri hazırlamak için kaynar sıcak su",
	"question1.option2.text": "İçmek için soğutulmuş ve sodalı su",
	"question1.option3.text": "Kaynar sıcak suyun yanında soğutulmuş ve sodalı su",
	"question2.question": "Ana bataryanız hangisi olmalı?",
	"question2.option1.text": "GROHE Blue Home",
	"question2.option2.text": "GROHE Red",
	"question3.question": "Hangi su çıkış ucu tasarımını tercih edersiniz?",
	"question3.option1.text": "L şeklinde çıkış ucu",
	"question3.option2.text": "U şeklinde çıkış ucu",
	"question3.option3.text": "C şeklinde çıkış ucu",
	"question4.question": "Hangi kaplamayı tercih edersiniz?",
	"question4.option1.text": "Krom",
	"question4.option2.text": "Paslanmaz Çelik",
	"question5.question": "Isıtıcınızın hangi boyutta olmasını istersiniz?",
	"question5.option1.text": "M Boyutu (3 Litre)",
	"question5.option2.text": "L Boyutu (5,5 Litre)",
	"results.title": "{productGroupsCount, plural, \none {Sonucunuz} \nother {Sonuçlarınız}\n}",
	"results.proposal.title": "Proposal {number}",
	"results.proposal.title.single": "Proposal",
	"results.bundle.title": "Doğru kurulum için şunlara da ihtiyaç duyabilirsiniz:",
	"results.newConfiguration.title": "Yeni bir su sistemi yapılandırmak ister misiniz?",
	"results.newConfiguration.buttonText": "Yeni bir su sistemi yapılandır",
	"results.product.number": "Ürün numarası: #{number}",
	"results.product.button.productInformation": "Ürün bilgisi",
	"results.product.button.dealerLocator": "Showroom arayın",
	"results.product.button.buyNow": "Buy Now",
	"results.product.button.downloadPDF": "Download PDF",
	"results.product.information": "Product Information",
	"results.product.dealer": "Showroom arayın",
	"hatchModal.title": "'Bilinmiyor",
	"hatchModal.btnText": "'Bilinmiyor",
	"hatchModal.stockInfo": "{stockQuantity, plural, \nzero {Not on Stock} \nother {On Stock}\n}",
	"hatchModal.buyNow": "Buy Now"
};


//////////////////
// WEBPACK FOOTER
// ./src/translations/water.tr_tr.json
// module id = 795
// module chunks = 0